module.exports = __webpack_public_path__ + "client/img/invest_02.424cde0c.png";